module.exports = __webpack_public_path__ + "img/bg@2x.7cbea15a.png";